const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const ADS_LABEL = process.env.REACT_APP_GOOGLE_ADS_LABEL;

const initMeta = () => {
  if (!PIXEL_ID || window.fbq) return;
  const n = (window.fbq = function () {
    n.queue.push(arguments);
  });
  n.queue = [];
  n.loaded = true;
  n.version = "2.0";
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(t);
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

const initGoogle = () => {
  if (!ADS_ID || window.gtag) return;
  const t = document.createElement("script");
  t.async = true;
  t.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(t);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", ADS_ID);
};

export const trackLead = () => {
  if (window.fbq) window.fbq("track", "Lead");
  if (window.gtag && ADS_ID && ADS_LABEL) {
    window.gtag("event", "conversion", { send_to: `${ADS_ID}/${ADS_LABEL}` });
  }
};

export const getSource = () => {
  const p = new URLSearchParams(window.location.search);
  const parts = [window.location.pathname];
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
    const v = p.get(k);
    if (v) parts.push(`${k}=${v}`);
  });
  return parts.join(" | ");
};

initMeta();
initGoogle();
